import Model from './Model'
import Resource from './Resource'

export default class ResourceCategory extends Model {
  resource() {
    return 'resource-categories'
  }
  resources() {
    return this.hasMany(Resource)
  }
}
